import createIcon from '../../createIcon';

/**
 * @component @name Panorama
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjMgMThWNkMyMyA0LjkgMjIuMSA0IDIxIDRIM0MxLjkgNCAxIDQuOSAxIDZWMThDMSAxOS4xIDEuOSAyMCAzIDIwSDIxQzIyLjEgMjAgMjMgMTkuMSAyMyAxOFpNOC41IDEyLjVMMTEgMTUuNTFMMTQuNSAxMUwxOSAxN0g1TDguNSAxMi41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Panorama = createIcon('Panorama', [
  [
    'path',
    {
      d: 'M23 18V6C23 4.9 22.1 4 21 4H3C1.9 4 1 4.9 1 6V18C1 19.1 1.9 20 3 20H21C22.1 20 23 19.1 23 18ZM8.5 12.5L11 15.51L14.5 11L19 17H5L8.5 12.5Z',
      key: '8yktl5',
    },
  ],
]);

export default Panorama;
